var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71875 10C1.71875 5.44365 5.4124 1.75 9.96875 1.75C14.5251 1.75 18.2188 5.44365 18.2188 10C18.2188 14.5563 14.5251 18.25 9.96875 18.25C5.4124 18.25 1.71875 14.5563 1.71875 10ZM9.96875 0.25C4.58397 0.25 0.21875 4.61522 0.21875 10C0.21875 15.3848 4.58397 19.75 9.96875 19.75C15.3535 19.75 19.7188 15.3848 19.7188 10C19.7188 4.61522 15.3535 0.25 9.96875 0.25ZM9.96875 5.5C9.55454 5.5 9.21875 5.83579 9.21875 6.25V6.2575C9.21875 6.67171 9.55454 7.0075 9.96875 7.0075H9.97625C10.3905 7.0075 10.7262 6.67171 10.7262 6.2575V6.25C10.7262 5.83579 10.3905 5.5 9.97625 5.5H9.96875ZM11.0509 10.2639C11.3617 9.02061 10.0711 7.98532 8.92483 8.55844L8.88334 8.57918C8.51286 8.76442 8.36269 9.21493 8.54793 9.58541C8.73317 9.95589 9.18368 10.1061 9.55416 9.92082V9.92082C9.57046 9.91267 9.58882 9.92739 9.5844 9.94508L8.88664 12.7361C8.57582 13.9794 9.86644 15.0147 11.0127 14.4416L11.0127 14.4416L11.0542 14.4208C11.4247 14.2356 11.5748 13.7851 11.3896 13.4146C11.2043 13.0441 10.7538 12.8939 10.3833 13.0792V13.0792C10.367 13.0873 10.3487 13.0726 10.3531 13.0549L11.0509 10.2639Z",
    fill: "#BE5400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.e140ccfb2523e11130daac55951fef55.svg";
export { ForwardRef as ReactComponent };